<template>
  <main role="main">
    <div class="text-center py-5">
      <p class="text-secondary">Không tìm thấy trang</p>
      <router-link to="/">Về trang chủ</router-link>
    </div>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class NotFound extends BaseComponent {

    mounted() {

    }

  }
</script>
